window.sfDocumentReady(['route-financiers'], () => {
  // initialize data table
  window.setupDatatable('.js-datatable', 'asc');
});

const SAVE_APPROVAL_ENDPOINT = '/approvals/save'
const DELETE_APPROVAL_PARAMETER_ENDPOINT = '/approvals/deleteParameter'
window.sfDocumentReady(['route-approvals-add', 'route-approvals-edit'], function() {
  // APPROVAL
  $('.js-approval-form').on('submit', function(e) {
    e.preventDefault();

    const data = $(this).serialize();
    window.httpPost(SAVE_APPROVAL_ENDPOINT, data, {
      success: response => {
        notifyBox('Saved', 'Approval details saved!', 'success')
        $('.js-display-errors').html('')

        const url = _.get(response, 'url') || '/approvals'
        setTimeout(() => redirect(url), 300);
      },
      error: xhr => {
        const errors = _.get(xhr, 'responseJSON.errors', {})

        _.forEach(errors, (fieldErrors, fieldName) => {
          $(`.js-display-errors#${fieldName.replace(/\./g, '-')}-err`).html(fieldErrors.join('<br>'))
        })
      }
    });
  });

  // APPROVAL PARAMETERS
  $('#addMore').on('click', function() {
    // Appending additional financier parameter to existing row
    $('#addParameterExisting').append($('.addNew').html());
    updateParameterKeys();
  });
  /* $('[name="id"]').val() && */ $('#addMore').trigger('click');

  $('body').on('click', '.deleteApproval', function() {//Delete
    var $this = $(this);
    if (confirm('Are you sure you want to delete this entry?')) {
      $this.closest('.approval-parameter').find('.deleteApproval').parent().remove();
    }
  });

  $('.js-delete-approval').on('click', function() {
    var approval_id = $(this).attr('data-id');
    var $this = $(this);
    if (!approval_id || !approval_id.length) {
      $this.closest('.approval-parameter').remove();
      updateParameterKeys();
    } else if (confirm('Are you sure you want to delete this parameter?')) {
      var data = {id: approval_id};
      window.httpGet(DELETE_APPROVAL_PARAMETER_ENDPOINT, data, {
        success: function(response) {
          if (response.status === 'success') {
            $this.closest('.approval-parameter').remove();
            updateParameterKeys();
          }
        },
      });
    }
    return false;
  });

  updateParameterOperators();
  $(document).on('change', '.parameter', updateParameterOperators);
});

function updateParameterKeys() {
  $('#addParameterExisting [name*="id"]').each(function(k, v) {
    $(this).attr('name', 'parameters[' + k + '][id]');
  });
  $('#addParameterExisting [name*="field"]').each(function(k, v) {
    $(this).attr('name', 'parameters[' + k + '][field]');
    $(this).parent().find('.js-display-errors').attr('id', 'parameters-' + k + '-field-err');
  });
  $('#addParameterExisting [name*="operator"]').each(function(k, v) {
    $(this).attr('name', 'parameters[' + k + '][operator]');
    $(this).parent().find('.js-display-errors').attr('id', 'parameters-' + k + '-operator-err');
  });
  $('#addParameterExisting [name*="value"]').each(function(k, v) {
    $(this).attr('name', 'parameters[' + k + '][value]');
    $(this).parent().find('.js-display-errors').attr('id', 'parameters-' + k + '-value-err');
  });
}

function updateParameterOperators() {
  $('.parameter').each(function () {
    const timeParameters = [
      'asset_age',
      'asset_age_term_sum',
      'gst_status_at', // Date of registration for GST
      'business_status_at', // Date of establishment of business
      'term',
    ];
    const timeOperators = [
      'older',
      'older_or_equal',
      'younger',
      'younger_or_equal',
    ];
    const timeOperatorsSelector = timeOperators.map(operator => `[value=${operator}]`).join(',');
    const timeOperatorFallbacks = {
      'older': '>',
      'older_or_equal': '>=',
      'younger': '<',
      'younger_or_equal': '<=',
    }

    const parameter = $(this).val()
    const operatorEl = $(this).closest('.approval-parameter').find('.operator')
    if (!timeParameters.includes(parameter)) {
      // hide all time operators
      operatorEl.find(timeOperatorsSelector).attr('hidden', true);
      // attempt applying fallback values
      const selectedOperator = operatorEl.val()
      if (_.has(timeOperatorFallbacks, selectedOperator)) {
        operatorEl.val(timeOperatorFallbacks[selectedOperator])
      }
    } else {
      // show all time operators
      operatorEl.find(timeOperatorsSelector).attr('hidden', false);
    }
  });
}
